import React, {useContext, useState} from 'react';
import {Modal, Row, Col} from "react-bootstrap";
import {MultiSelectFormContext} from "~/contexts/MultiSelectForm";
import Title from "~/shared/Title";
import Button from "~/shared/Btn";
import styled from 'styled-components'

const ImgContainer = styled.div`
    text-align: center;
    padding: 2rem 1rem;

    img {
        width: 100%;
        max-width: 475px;
    }
`

const BoxContainer = styled.div`

    p {
        margin: 1rem 0;
        font-size: 1rem;
        line-height: 1.5rem;
    }
`

const SportsModal = () => {
    const { handleChange } = useContext(MultiSelectFormContext);
    const[isOpen, setIsOpen] = useState(true)

  return (
      <Modal size="lg" show={isOpen} onHide={ () => {
          setIsOpen(false)
          handleChange("category", 0)
      }}>
            <Modal.Header>
                <Title level="2">
                    Qual segmento de eventos de esporte?
                </Title>
            </Modal.Header>
          <Modal.Body>
              <ImgContainer>
                  <img  src="/images/esportivo-mktp.png" alt="imagem de seleção de opção" />
              </ImgContainer>
              <Row>
                  <Col lg={6}>
                      <BoxContainer>
                          <Button block onClick={ () => window.location.href = 'https://fotop.io/organizador/'}>Quero fotos para vender aos atletas do meu evento</Button>
                          <p>
                              Se você é organizador ou atleta de um evento e quer que o Fotop envie fotógrafos para fotografarem os participantes
                              e disponibilizar às fotos a venda, permitindo a busca por reconhecimento facial ou número de peito, clique nesta opção.
                          </p>
                      </BoxContainer>
                  </Col>
                  <Col lg={6}>
                      <BoxContainer>
                          <Button block onClick={ () => handleChange("category", 24)}>Quero orçamento de fotógrafo para cobrir o meu evento</Button>
                          <p>
                              Se você quer contratar diretamente um fotógrafo para registrar e documentar seu evento,
                              clique nesta opção, e informe mais detalhes para receber diversos orçamentos sem compromisso.
                          </p>
                      </BoxContainer>
                  </Col>

              </Row>
          </Modal.Body>
      </Modal>
  );
};

export default SportsModal;
